module.exports = __webpack_public_path__ + "static/media/eye-regular.35985bde.svg";